export default {
  title: 'Adăugați partener',
  mode: {
    single: 'Partener individual',
    bulk: 'Bulk (CSV)',
  },
  buttons: {
    send_invite: 'Trimiteți invitația',
  },
  bulk: {
    form: {
      file: {
        label: 'Listă parteneri (CSV)',
        hint: 'Un partener pe rând. Coloane obligatorii: Email, Țara companiei și Numele înregistrat sau Numele companiei. Numele de marcă este opțional și devine numele afișat consumatorilor. Fiecare rând este validat înainte de creare.',
      },
    },
    buttons: {
      select_file: 'Selectați fișierul CSV',
      download_template: 'Descarcă șablonul de import',
      import: 'Importați parteneri',
    },
    columns: {
      legal_name: 'Nume înregistrat / Numele companiei',
      display_name: 'Nume de marcă',
      admin_email: 'Email',
      company_country: 'Țara companiei',
    },
    errors: {
      title: 'Fișierul nu a putut fi importat.',
      nothing_imported: 'Niciun partener nu a fost creat. Corectați rândurile de mai sus și reîncărcați fișierul.',
      columns: {
        row: 'Rând',
        column: 'Coloană',
        error: 'Eroare',
      },
    },
    toasts: {
      queued_one:
        '{{count}} partener în așteptare — invitațiile sunt trimise pe măsură ce fiecare este creat. Veți primi un email rezumat când importul se finalizează.',
      queued_few:
        '{{count}} parteneri în coadă — invitațiile se trimit pe măsură ce fiecare este creat. Vei primi un e-mail rezumat la finalizarea importului.',
      queued_other:
        '{{count}} parteneri în așteptare — invitațiile sunt trimise pe măsură ce fiecare este creat. Veți primi un email rezumat când importul se finalizează.',
    },
    footnote:
      'Partenerii sunt creați unul câte unul în fundal, cu aceeași configurare ca un singur partener: email de invitație, subdomeniu de dashboard și domeniu de magazin implicit. Țara determină moneda și fusul orar; un stat poate fi setat ulterior din profilul partenerului. Procesarea plăților se configurează ulterior în tab-ul Plăți al fiecărui partener.',
  },
  form: {
    name: {
      label: 'Numele partenerului',
    },
    admin_email: {
      label: 'E-mail administrator (destinatar invitație)',
      hint: 'Vom trimite o invitație prin e-mail pentru configurarea contului.',
    },
    display_name: {
      label: 'Nume afișat consumatorilor',
      hint: 'Eticheta „Powered by ___" afișată clienților. Implicit, se folosește numele partenerului.',
    },
    region: {
      label: 'Țară',
      placeholder: 'Selectați o țară',
      hint: 'Stabilește moneda, fusul orar și limba invitației partenerului.',
      summary: 'Monedă {{currency}} · {{timezone}} · Limbă invitație {{language}}',
      default_root: 'Domeniu magazin: brandurile noi sunt găzduite pe {{host}}',
    },
    sub_region: {
      label: 'Regiune',
      placeholder: 'Toată țara',
      hint: 'Opțional — lăsați gol pentru a aplica la nivel național.',
    },
    language: {
      label: 'Limba invitației',
      placeholder: '{{language}} (implicit)',
      hint: 'Opțional — implicit, limba principală a țării.',
    },
  },
  footnote: 'Setările de branding și câștiguri pot fi configurate după ce partenerul acceptă invitația.',
  toasts: {
    created: 'Partener creat — e-mailul de invitație a fost trimis.',
  },
};
